import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
// import './assets/css/styles.css';
import "font-awesome/css/font-awesome.css";
import App from "containers/App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "redux/store.js";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
